import { supabase } from '@/lib/supabaseClient';
import { invalidateSystemConfig } from '@/lib/fetchSystemConfig';
import type { RestaurantBrandingInput } from '@/types/branding';
import type { SystemConfig } from '@/types/systemConfig';

async function patchSystemConfig(patch: Record<string, unknown>): Promise<SystemConfig> {
  const { data, error } = await supabase
    .from('system_config')
    .update(patch)
    .eq('id', 1)
    .select('*')
    .single();

  if (error || !data) {
    throw new Error(error?.message ?? 'Marka ayarları güncellenemedi.');
  }

  invalidateSystemConfig();
  return data as SystemConfig;
}

/** Restoran sahibi markalama ayarları */
export async function updateRestaurantBranding(input: RestaurantBrandingInput): Promise<SystemConfig> {
  const patch: Record<string, unknown> = { ...input };
  if (input.restaurant_logo_url !== undefined) {
    patch.logo_url = input.restaurant_logo_url;
  }
  const config = await patchSystemConfig(patch);

  if (input.restaurant_logo_url !== undefined) {
    await supabase.from('site_settings').upsert(
      { key: 'logo_url', value: input.restaurant_logo_url },
      { onConflict: 'key' },
    );
  }

  return config;
}
